import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import './app.scss';

// Registro components globales, disponibles en cada page (con prefix ca)
import CaChip from './components/CaChip.vue';
import CaExpansionPanels from './components/CaExpansionPanels.vue';
import CaLabelDato from './components/CaLabelDato.vue';
import CaLabelMonto from './components/CaLabelMonto.vue';
import CaModal from './components/CaModal.vue';
import CaPanel from './components/CaPanel.vue';
import CaSnackbar from './components/CaSnackbar.vue';
import CaTabla from './components/CaTabla.vue';
import CaTooltip from './components/CaTooltip.vue';
import CaBottomNav from './components/CaBottomNav.vue';
import CaFiltro from './components/CaFiltro.vue';
import CaDatasheet from './components/CaDatasheet.vue';
import CaInputDatepicker from './components/CaInputDatepicker.vue';
import CaSidesheet from '@/components/CaSidesheet.vue';
import CaChipsbar from '@/components/CaChipsbar.vue';
import CaChipFiltros from '@/components/CaChipFiltros.vue';
import CaEmptyState from '@/components/CaEmptyState.vue';
import CaInputCopiable from '@/components/CaInputCopiable.vue';
import CaTooltipJira from '@/components/CaTooltipJira.vue';

Vue.component('ca-chip', CaChip);
Vue.component('ca-expansion-panels', CaExpansionPanels);
Vue.component('ca-label-dato', CaLabelDato);
Vue.component('ca-label-monto', CaLabelMonto);
Vue.component('ca-modal', CaModal);
Vue.component('ca-panel', CaPanel);
Vue.component('ca-snackbar', CaSnackbar);
Vue.component('ca-tabla', CaTabla);
Vue.component('ca-tooltip', CaTooltip);
Vue.component('ca-bottom-nav', CaBottomNav);
Vue.component('ca-filtro', CaFiltro);
Vue.component('ca-datasheet', CaDatasheet);
Vue.component('ca-input-datepicker', CaInputDatepicker);
Vue.component('ca-sidesheet', CaSidesheet);
Vue.component('ca-chipsbar', CaChipsbar);
Vue.component('ca-chip-filtros', CaChipFiltros);
Vue.component('ca-empty-state', CaEmptyState);
Vue.component('ca-input-copiable', CaInputCopiable);
Vue.component('ca-tooltip-jira', CaTooltipJira);

// Registro filtros globales
import { FormatFecha, FormatMontoCentavos, FormatMonto } from './components/vue_filters';
import { GuionSiEsNulo, trimUsuarioSales } from './views/acuerdo-comercial/acuerdo-comercial.helpers';

Vue.filter('formatFecha', FormatFecha);
Vue.filter('formatMontoCentavos', FormatMontoCentavos);
Vue.filter('formatMonto', FormatMonto);
Vue.filter('trimUsuarioSales', trimUsuarioSales);
Vue.filter('guionSiEsNulo', GuionSiEsNulo);

// Imports plugins Amplify
import { AUTH_SERVICE } from '@/services/auth.service';
AUTH_SERVICE.inicializarConfiguracion();

Vue.config.productionTip = false;

// Bus de eventos globales, utiliza la instancia de vue "vacia" (sin template, ni DOM, y sin logica de renderizado) se utiliza unicamente para comunicación entre componentes
export const EventBus = new Vue();

// Instancia principal y completa de Vue
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');